var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.0078125H513V341.992H0V-0.0078125Z",
    fill: "#1E509C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 176.092V81.292L0 341.992L513 176.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 -0.0078125V81.2922L0 341.992L513 -0.0078125Z",
    fill: "#F18D36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.7 99.2924L118.9 45.1924L111.2 99.2924L90.4001 75.5924L101.1 107.192L69.6001 96.4924L93.2001 117.292L39.1001 124.992L93.2001 132.692L69.6001 153.492L101.1 142.792L90.4001 174.392L111.2 150.692L118.9 204.792L126.7 150.692L147.4 174.392L136.8 142.792L168.3 153.492L144.7 132.692L198.7 124.992L144.7 117.292L168.3 96.4924L136.8 107.192L147.4 75.5924L126.7 99.2924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMh);
export default __webpack_public_path__ + "static/media/MH.97741dab0550291c8647f784e380ee6e.svg";
export { ForwardRef as ReactComponent };